import { EmployeesListCheckbox } from "../EmployeesListCheckbox/EmployeesListCheckbox";

import EmployeesListContext from "../EmployeesListContext/EmployeesListContext";

import WOHHelper from "../WOHHelper.service";

import React, { useContext, useEffect, useState } from "react";
import moment from "moment";

export const EmployeesListItem = ({ employer, employees, selectedE, setSelectedE }) => {
    const [selected, setSelected] = useState(false);

    const { employeesSelected, employeesSelectedToggle } = useContext(EmployeesListContext);

    function onChangeHandler() {
        setSelected((prev) => !prev);
        employeesSelectedToggle(employer.agreement.uid);
        if (!selectedE.length || !selectedE.includes(employer.agreement.uid)) {
            setSelected(true);
            setSelectedE((prev) => [...prev, employer.agreement.uid]);
        } else {
            setSelectedE(selectedE.filter((item) => item !== employer.agreement.uid));
            setSelected(false);

        }
    }

    const card = {
        jobDate: WOHHelper.getJobDates(employer.days).join(", "),
        jobHours: WOHHelper.getJobHours(employer.days).join(", "),
        compensationType: WOHHelper.getCompensationTypes(employer.days).join(", "),
        restDate: WOHHelper.getRestDates(employer.days).join(", "),
        statusName: employer.agreement.statusName,
        status: employer.agreement.status,
    };

    useEffect(() => {
        if (WOHHelper.statusFiltered(employer.status)) {
            if (!employeesSelected.has(employer.agreement.uid)) {
                setSelected(true);
                employeesSelectedToggle(employer.agreement.uid);
            } else {
                setSelected(employeesSelected.get(employer.agreement.uid));
            }
        }

    }, [employeesSelected]);
    return (
        <div className={[
            "request-modal__table__line",
            "employee-request_status__",

        ].join(" ")}>
            {/*+ WOHHelper.getStatusType(employer.status),*/}
            <div className={`left-column 
             ${card?.status && card?.status > 4  ? "employee-request_status__not-confirmed" : null} `}>
                <div className="employer-name">
                    <p>
                        {card?.status && card?.status < 5 ?
                            <EmployeesListCheckbox
                                checked={selected ||
                                    employeesSelected.has(employer.agreement.uid) && employeesSelected.get(employer.agreement.uid)}
                                onChange={onChangeHandler}
                                disabled={WOHHelper.statusFiltered(card.status)}
                            /> : null}
                        {employer.fullName}</p>

                </div>
                <div className="employer-tabel">{employer.tabNumber}</div>
                <div className="employer-grade">{employer.jobTitle}</div>
            </div>
            <div className="right-column">

                <div className="employer-info">
                    <span>Дата привлечения - {card.jobDate} </span>
                </div>
                <div className="employer-info">
                    <span>Количество часов - {card.jobHours}</span>
                </div>
                <div className="employer-info">
                    <span>Порядок компенсации - {card.compensationType}</span>
                </div>

                {
                    card.restDate &&
                    <div className="employer-info">
                        <span>Дата отдыха - {card.restDate}</span>
                    </div>
                }

                <div className="employer-info">
                    <span>Статус -{" "}
                        <span
                            className={`employee-request-status
                         ${card?.status && card?.status === 4 ? "green" : null}
                          ${card?.status && card?.status  < 4  ? "black" : null}
                          ${card?.status && card?.status  > 4  ? "red" : null}`}>
                            {card.statusName}
                        </span>
                    </span>
                </div>

            </div>
        </div>
    );
};
